export interface Shortcut {
  keys: string[]
  description: string
  category: string
}

export const shortcuts: Shortcut[] = [
  { keys: ['Cmd', 'K'], description: 'Open command palette', category: 'Navigation' },
  { keys: ['?'], description: 'Show keyboard shortcuts', category: 'Navigation' },
  { keys: ['G', 'H'], description: 'Go to dashboard', category: 'Navigation' },
  { keys: ['G', 'B'], description: 'Go to build', category: 'Navigation' },
  { keys: ['G', 'S'], description: 'Go to settings', category: 'Navigation' },
  { keys: ['Cmd', 'Enter'], description: 'Start build', category: 'Build' },
  { keys: ['Cmd', 'N'], description: 'New content session', category: 'Content Studio' },
  { keys: ['Escape'], description: 'Close modal / cancel', category: 'General' },
]
